<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="documents-info syue-clr">
    <p class="head-portrait syue-left">{{getCompanyName(activeMsgItem, '-') + activeMsgItem.toName ? (getCompanyName(activeMsgItem, '-') + activeMsgItem.toName).slice(0, 1) : '-'}}</p>
      <div class="user-info syue-left">
        <!-- {{activeMsgItem}} -->
        <p class="name">{{getCompanyName(activeMsgItem, '-')}}{{activeMsgItem.toName}} <span class="identity">({{getIdentity(activeMsgItem) || '-'}})</span></p>
        <p class="info">{{activeMsgItem.applyFormName}}:<span class="document-id" @click="handleClick"> {{acceptorId}}<span class="el-icon-arrow-right"></span></span></p>
      </div>
    
  </div>
</template>

<script>
import mixin from './../mixin'
export default {
  mixins: [ mixin ],
  props: {
    activeMsgItem: {
      type: Object
    },
    acceptorId: {
      type: String
    },
    acceptorInfo: {
      type: Object
    }
  },
  methods: {
    handleClick () {
      if (this.getUrl !== '') {
        window.open(window.fe.baseUrl + this.getUrl)
      }
    }
  },
  computed: {
    getUrl () {
      let item = null
      for (let key in this.CLIENT_TYPE_CONST) {
        if (this.CLIENT_TYPE_CONST[key].code === this.activeMsgItem.clientType) {
          item = this.CLIENT_TYPE_CONST[key]
        }
      }
      return item ? this.activeMsgItem[item.url]  : ''
    }
  }
}
</script>

<style scoped lang="scss">
.documents-info{
  padding: 12px 16px ;
  line-height: 20px;
  font-size: 14px;
  color: #303030;
  background: #fff;
  border-bottom: 1px solid #EEEEEE;
  .link {

  }
  .document-id{
    color: #303030;
    cursor: pointer;
  }
  .icon-jiantou{
    color: #303030;
    font-size: 12px;
    text-indent: 0px;
  }
  .head-portrait{
    width: 36px;
    height: 36px;
    background: #1E7AFC;
    border-radius: 22px;
    text-align: center;
    line-height: 36px;
    font-size: 18px;
    color: #A5C9FD;
  }
  .user-info {
    margin-left: 10px;
    padding-left: 2px;
    width: 300px;
  }
  .name{
    line-height: 20px;
    font-size: 14px;
  }
  .identity{
    line-height: 20px;
    font-size: 12px;
    color: #BBBBBB;
  }
  .info{
    line-height: 16px;
    font-size: 12px;
  }
}
</style>